/**
 * isAppleStore变量的含义是： 是否上架到苹果app store
 *
 * 如果上架到苹果app store的话，第三方oAuth登录功能是不能上架的。只是打企业包
 * 所以当功能要上架到苹果appStore时，需要把 main.js的 isAppleStore 设置为true，isAppleStore为true时，oAuth登录功能会被隐藏。
 *
 * 暂时忽略这个变量。现在oAuth登录上传到app store了
 */

import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import "./registerServiceWorker"
// 蓝湖日志库
import LanhuLogger from "@lanhu-logger/sdk-web"
Vue.prototype.logger = new LanhuLogger({
    endpoint: "cn-beijing.log.aliyuncs.com",
    project: "lanhu-logger",
    logStore: "magic-board-web",
    topic: "lanhu-app",
    environment: "development",
    appVersion: new Date(),
    userId: localStorage.getItem("user_id") || "这是用户 id",
    firstUserParam: localStorage.getItem("team_id") || "这是用户第一个参数",
    secondUserParam: localStorage.getItem("email") || "这是用户第二个参数"
});

//备注映射
import remark from '@/common/js/remark.js'
//socket通知
import socketNotify from "@/common/js/socketNotify.js"
//rem
import "@/common/js/rem.js"
//一像素细线
import "@/assets/css/border.css"
//material图标
import "@/assets/iconfont/material-icons/material-icons.css"
//css动画库
import "@/assets/css/animate.css"
//解决300毫秒点击延迟
import fastClick from "fastclick"
fastClick.attach(document.body)
import VTooltip from "v-tooltip"
Vue.use(VTooltip)

//touch-event
var VueTouch = require("vue-touch")
VueTouch.registerCustomEvent("doubletap", {
    type: "tap",
    taps: 2
})

Vue.use(VueTouch, { name: "v-touch" })

//mint-ui
import Mint from "mint-ui"
import "mint-ui/lib/style.css"
Vue.use(Mint)
//global
import "@/common/js/global/global"
//settings
import set from "./settings"

window.setBase = set
let settingsData = window.setBase()
let isWebview = settingsData.isWebview
let useCustomServer = settingsData.useCustomServer
Vue.prototype.domain = window.domain

//API
import API from "@/api/api"

window.API = API

//系统
function judgeSystem() {
    let u = navigator.userAgent
    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

    return isAndroid ? "android" : isIOS ? "ios" : ""
}

window.system = judgeSystem()
//设备相关信息
let device = {
    direction: "portrait",
    size: {
        width: 0,
        height: 0
    }
}

//判断设备横竖屏
function judgeDeviceDirection() {
    if (window.orientation === 0 || window.orientation == 180) {
        device.direction = "portrait"
    } else if (window.orientation == 90 || window.orientation == -90) {
        device.direction = "landscape"
    }
}
judgeDeviceDirection()

//获取设备尺寸
function getDeviceSize() {
    let width = document.body.clientWidth //documentElement 获取不到正确的高度    body可以  应该是webview的问题
    let height = document.body.clientHeight

    device.size = { width, height }
}

getDeviceSize()

function isChanged() {
    let nowDir = ""
    if (window.orientation === 0 || window.orientation == 180) {
        // 竖屏
        nowDir = "portrait"
    } else if (window.orientation == 90 || window.orientation == -90) {
        // 横屏
        nowDir = "landscape"
    }

    if (device.direction == nowDir) {
        return false
    } else {
        return true
    }
}

window.addEventListener("orientationchange", () => {
    // alert('orientationchange触发了')
    if (isChanged()) {
        let width = device.size.width
        let height = device.size.height
        device.size = {
            width: height,
            height: width
        }

        judgeDeviceDirection()
    }
})

//是否支持webp
function check_support_webp() {
    return document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0;
}

window.isSupportWebp = check_support_webp();

//统计
import MtaH5 from "mta-h5-analysis"
function count() {
    window.MtaH5 = MtaH5

    let sid = "",
        cid = ""
    if (window.system == "ios") {
        sid = "500662581"
        cid = "500662585"
    } else if (window.system == "android") {
        sid = "500662611"
        cid = "500662612"
    }

    MtaH5.init({
        sid: sid, //必填，统计用的appid
        cid: cid, //如果开启自定义事件，此项目为必填，否则不填
        autoReport: 0, //是否开启自动上报(1:init完成则上报一次,0:使用pgv方法才上报)
        senseHash: 1, //hash锚点是否进入url统计
        senseQuery: 0, //url参数是否进入url统计
        performanceMonitor: 0, //是否开启性能监控
        ignoreParams: [] //开启url参数上报时，可忽略部分参数拼接上报
    })

    //访问页面统计
    MtaH5.pgv()
}

count()
Vue.config.productionTip = false
socketNotify()
window.vm = new Vue({
    router,
    render: h => h(App),
    data() {
        return {
            eventBus: new Vue(),
            device,
            remark,
            system: window.system,
            isWebview,
            useCustomServer,
            isAppleStore: false,
            isSupportWebp
        }
    }
}).$mount("#app")
